import { ApiClient, ApiClientConfig } from "../api-client";
import { ApiClientError } from "../errors";
import schemaValidators from "./schema-validators";

type SupportEmail = {
	name: string;
	email: string;
	subject: string;
	message: string;
};

export default class SupportEmailClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, {});
	}

	sendSupportEmail = async ({ name, email, subject, message }: SupportEmail) => {
		try {
			const res = await super.fetch(new URL(`/api/verity/support/email`, this.config.verityOrigin), {
				method: "POST",
				body: JSON.stringify({ name: name, email: email, subject: subject, message: message }),
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (res.ok) {
				return true;
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
